<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-cloud-download"></i> Exports
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">
        <ContentTitle>Inventory Exports</ContentTitle>
        <FormRow label="Stock Export">
          <FormButton class="btn-default" @click="exportFile('stock')"><i class="far fa-file-csv"></i> Download CSV</FormButton>
        </FormRow>
        <FormRow label="Glass Sizes Export">
          <FormButton class="btn-default" @click="exportFile('glasssizes')"><i class="far fa-file-csv"></i> Download CSV</FormButton>
        </FormRow>
        

        <FormHorizontalRule />
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'

export default {
  name: 'AdminToolExport',
  mixins: [form],
  components: {
  },
  mounted() {
  },
  methods: {
    exportFile(exportType) {
      this.$apiService.reportingService.generateReportSignedURL(`/inventory/export/${exportType}`)
      .then(response => {
        window.location.href = response.data.url
      })
    }
     
  }
}

</script>